export default function SimpleResult({ onSelect = () => { }, text }: {
  onSelect?: (text: string) => void;
  text: string;
}) {
  return (
    <div onClick={() => onSelect(text)} className="tw-leading-[21px] tw-group tw-cursor-pointer tw-whitespace-nowrap">
      {text}
    </div>
  )
}

